import React, { ReactElement } from 'react'
import { PageContainer } from '@copyrightagent/basic-components'
import useSetPageTitle from 'hooks/useSetPageTitle'
import useStyle from './style'
import Navigation from '../HomeLayout/Navigation'
import TransferAgreementsList from './components/TransferAgreementsList'
import { PageBody, Typography } from '@copyrightagent/basic-components'
import {
	NoTransferAgreementSelected,
	TransferAgreementDetails,
} from './components/TransferAgreementDetails'
import {
	Route,
	Switch,
	RouteComponentProps,
	withRouter,
} from 'react-router-dom'

const TransferAgreementsPage = ({
	match,
}: RouteComponentProps): ReactElement => {
	const classes = useStyle()

	useSetPageTitle('Transfer of Rights Agreements')

	return (
		<>
			<Navigation />
			<PageContainer className={classes.container}>
				<Typography variant="h5" className={classes.title}>
					Transfer of Rights Agreements
				</Typography>

				<PageBody className={classes.bodyContainer}>
					<div style={{ marginTop: 20, display: 'flex' }}>
						<Route path={match.path} component={TransferAgreementsList} />
						<div className={classes.divider} />
						<Switch>
							<Route
								exact
								path={match.path}
								component={NoTransferAgreementSelected}
							></Route>
							<Route
								path={`${match.path}/:transferAgreementId`}
								component={TransferAgreementDetails}
							/>
						</Switch>
					</div>
				</PageBody>
			</PageContainer>
		</>
	)
}

export default withRouter(TransferAgreementsPage)
